export const GET_PLUGIN_ADMIN_CATALOG_REQUEST = "GET_PLUGIN_ADMIN_CATALOG_REQUEST";
export const GET_PLUGIN_CLIENTS_REQUEST = "GET_PLUGIN_CLIENTS_REQUEST";
export const GET_PLUGIN_AVAILABLE_CLIENTS_REQUEST = "GET_PLUGIN_AVAILABLE_CLIENTS_REQUEST";
export const ENABLE_PLUGIN_CLIENT_REQUEST = "ENABLE_PLUGIN_CLIENT_REQUEST";
export const DISABLE_PLUGIN_CLIENT_REQUEST = "DISABLE_PLUGIN_CLIENT_REQUEST";

export const getPluginAdminCatalog = (callback) => ({
    type: GET_PLUGIN_ADMIN_CATALOG_REQUEST,
    payload: { callback },
});

export const getPluginClients = (pluginId, callback) => ({
    type: GET_PLUGIN_CLIENTS_REQUEST,
    payload: { pluginId, callback },
});

export const getPluginAvailableClients = (pluginId, callback) => ({
    type: GET_PLUGIN_AVAILABLE_CLIENTS_REQUEST,
    payload: { pluginId, callback },
});

export const enablePluginClient = (pluginId, clientId, callback) => ({
    type: ENABLE_PLUGIN_CLIENT_REQUEST,
    payload: { pluginId, clientId, callback },
});

export const disablePluginClient = (pluginId, clientId, callback) => ({
    type: DISABLE_PLUGIN_CLIENT_REQUEST,
    payload: { pluginId, clientId, callback },
});
